/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetReportDefinitionByReportTypeQueryResponse, AuditReportsGetReportDefinitionByReportTypePathParams, AuditReportsGetReportDefinitionByReportTypeQueryParams, AuditReportsGetReportDefinitionByReportType400, AuditReportsGetReportDefinitionByReportType401, AuditReportsGetReportDefinitionByReportType403, AuditReportsGetReportDefinitionByReportType404 } from "../models/AuditReportsGetReportDefinitionByReportType";

export function getAuditReportsGetReportDefinitionByReportTypeUrl(reportType: AuditReportsGetReportDefinitionByReportTypePathParams["reportType"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/report-definitions/default/${reportType}` as const }
  return res
}

/**
 * @description Retrieves the default report definition for the specified report type. For the specified blueprint version (or latest if not provided), returns the default definition. If definitionId is provided, returns that specific definition instead. If no default definition exists, creates and saves a default one from the blueprint.
 * @summary Get default report definition
 * {@link /audit-reports/v1/report-definitions/default/:reportType}
 */
export async function auditReportsGetReportDefinitionByReportType(reportType: AuditReportsGetReportDefinitionByReportTypePathParams["reportType"], params?: AuditReportsGetReportDefinitionByReportTypeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetReportDefinitionByReportTypeQueryResponse, ResponseErrorConfig<AuditReportsGetReportDefinitionByReportType400 | AuditReportsGetReportDefinitionByReportType401 | AuditReportsGetReportDefinitionByReportType403 | AuditReportsGetReportDefinitionByReportType404>, unknown>({ method : "GET", url : getAuditReportsGetReportDefinitionByReportTypeUrl(reportType).url.toString(), params, ... requestConfig })
  return res.data
}